import { api, URLs } from '@/libs/api'
import type { ApiResponse, CreateApiResult, CursorPagination } from '@/libs/interfaces'
import { leavesApiMock } from '@/libs/mocks/handlers/leaves'

export interface Leave {
  startAt: string
  endAt: string
  employeeID: string
  storeID: string
  createdAt: string
  updatedAt: string
}

export interface LeaveItem {
  startAt: string
  endAt: string
}

export interface LeaveListItem {
  employeeID: string
  startAt: string
  endAt: string
}

export interface LeaveListData extends CursorPagination {
  leaves: LeaveListItem[]
}

export interface LeaveListParams {
  storeID: string
}

const leavesApiReal = {
  create: (
    params: { employeeID: string; storeID: string },
    payload: LeaveItem[],
  ): Promise<CreateApiResult<void>> =>
    api.post<void>(URLs.Leaves.create(params.employeeID, params.storeID), {
      leaves: payload,
    }),

  delete: async (
    params: { employeeID: string; storeID: string },
    payload: LeaveItem[],
  ): Promise<void> => {
    await api.delete(URLs.Leaves.delete(params.employeeID, params.storeID), payload)
  },

  getByRange: async (params: {
    employeeID: string
    storeID: string
    leaveStart: string
    leaveEnd: string
  }): Promise<Leave> => {
    return api
      .get<ApiResponse<Leave>>(
        URLs.Leaves.getByRange(
          params.employeeID,
          params.storeID,
          params.leaveStart,
          params.leaveEnd,
        ),
      )
      .then((r) => r.data.data)
  },

  list: async (storeID: string): Promise<LeaveListData> => {
    return api.get<ApiResponse<LeaveListData>>(URLs.Leaves.list(storeID)).then((r) => r.data.data)
  },
}

export const leavesApi: typeof leavesApiReal = __IS_MOCK_MODE__ ? leavesApiMock : leavesApiReal
